import React, {Component} from 'react';
import {Menu} from 'semantic-ui-react';
import {NavLink, Switch} from 'react-router-dom';
import styled from 'react-emotion';
import {connect} from 'react-redux';

import Page from '../layout/Page';
import AllBlacklistsTable from '../blacklists/AllBlacklistsTable';
import RequiresRole, {ROLES} from '../security/RequiresRole';
import AuthorizedRoute from '../security/AuthorizedRoute';
import AllBlacklistedDomainTable from './AllBlacklistedDomainTable';
import NewBlacklistDomainScreen from './NewBlacklistDomainScreen';
import NewBlacklistScreen from './NewBlacklistScreen';

const PageWrapper = styled(Page.Basic)`
  .ui.menu .item {
    height: 42px;

    > .label.request-badge {
      background: #dfae38;
    }
  }
`;

class IndexScreen extends Component {
  render() {
    return (
      <PageWrapper
        title="Manage Blacklist"
        secondary={
          <Menu secondary pointing>
            <RequiresRole roles={[ROLES.SYSTEM_ADMIN]}>
              <Menu.Item as={NavLink} to="/manage/blacklists" exact>
                Blacklisted Users
              </Menu.Item>
              <Menu.Item as={NavLink} to="/manage/blacklists/new">
                Blacklist a User
              </Menu.Item>
              <Menu.Item as={NavLink} to="/manage/blacklists/domains" exact>
                Blacklisted Domains
              </Menu.Item>
              <Menu.Item as={NavLink} to="/manage/blacklists/domains/new">
                Blacklist New Domain
              </Menu.Item>
            </RequiresRole>
          </Menu>
        }
      >
        <Switch>
          <AuthorizedRoute
            exact
            path="/manage/blacklists"
            component={AllBlacklistsTable}
            roles={[ROLES.SYSTEM_ADMIN]}
          />
          <AuthorizedRoute
            exact
            path="/manage/blacklists/new"
            component={NewBlacklistScreen}
            roles={[ROLES.SYSTEM_ADMIN]}
          />
          <AuthorizedRoute
            exact
            path="/manage/blacklists/domains"
            component={AllBlacklistedDomainTable}
            roles={[ROLES.SYSTEM_ADMIN]}
          />
          <AuthorizedRoute
            exact
            path="/manage/blacklists/domains/new"
            component={NewBlacklistDomainScreen}
            roles={[ROLES.SYSTEM_ADMIN]}
          />
        </Switch>
      </PageWrapper>
    );
  }
}

const mapStateToProps = ({identity}) => {
  return {
    user: identity.user,
  };
};

export default connect(mapStateToProps)(IndexScreen);
